import React from "react";
import { Routes, Route, useParams, useSearchParams } from "react-router-dom";
import HomePage from "./components/HomePage";
import VideoCallPage from "./components/VideoCallPage";
import WelcomePage, { WelcomePageWithParams } from "./components/WelcomePage";
import VisitorCheckIn from "./components/VisitorCheckIn";
import GuestPass from "./components/GuestPass";
import "./App.css";

// 包装组件来处理URL参数
const HomePageWithParams: React.FC = () => {
  const { deviceId } = useParams<{ deviceId?: string }>();
  const [searchParams] = useSearchParams();
  const qrSecret = searchParams.get("code");

  return <HomePage deviceId={deviceId} qrSecret={qrSecret || undefined} />;
};

function App() {
  return (
    <div className="App">
      <Routes>
        {/* 新的路由匹配后端URL结构 - 先显示欢迎页面 */}
        <Route
          path="/virtual-intercom/:deviceId"
          element={<WelcomePageWithParams />}
        />
        {/* 主页面路由 - 从欢迎页面点击后进入 */}
        <Route
          path="/virtual-intercom/:deviceId/home"
          element={<HomePageWithParams />}
        />
        {/* 视频通话页面路由 - 通用 */}
        <Route path="/video-call" element={<VideoCallPage />} />
        {/* 访客登记页面路由 */}
        <Route path="/visitor-checkin" element={<VisitorCheckIn />} />
        {/* 访客通行证页面路由 */}
        <Route path="/guest-pass" element={<GuestPass />} />
        {/* 默认主页面 - 从欢迎页面点击后进入 */}
        <Route path="/home" element={<HomePage />} />
        {/* 默认欢迎页面 */}
        <Route path="/" element={<WelcomePage />} />
      </Routes>
    </div>
  );
}

export default App;
